/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

export enum Position {
  Left = 'left',
  Right = 'right',
}

const HYDRA_TOP_NAV_PORTAL_ID_MAP: Record<Position, string> = {
  left: 'hydra-top-nav-portal-left',
  right: 'hydra-top-nav-portal-right',
} as const;

interface Signature {
  Args: {
    position?: Position;
  };
}

const isValidPosition = (position: unknown): position is Position => {
  return Object.values(Position).includes(position as Position);
};

export default class HydraTopNavPortal extends Component<Signature> {
  get hydraTopNavAppContainer() {
    let { position } = this.args;

    if (!isValidPosition(position)) {
      position = Position.Right;
    }

    return document.getElementById(HYDRA_TOP_NAV_PORTAL_ID_MAP[position]);
  }
}
